// react/src/strict/app/overlays/SessionExpiredOverlay.tsx
import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Box, Button, Modal, Typography } from "@mui/material";

export const SessionExpiredOverlay: React.FC = () => {
  const { loginWithRedirect } = useAuth0();

  const handleSignIn = (): void => {
    const returnTo = window.location.hash.slice(1) || "/";
    // Don't clear the overlay first — remounting the app would let AuthenticationGuard fire a
    // second, competing loginWithRedirect before this one navigates.
    void loginWithRedirect({ appState: { returnTo } });
  };

  return (
    <Modal
      open
      aria-labelledby="session-expired-title"
      aria-describedby="session-expired-description"
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Box
        sx={{
          backgroundColor: "background.paper",
          borderRadius: 2,
          p: 4,
          maxWidth: 400,
          width: "90%",
          textAlign: "center",
          outline: "none",
        }}
      >
        <Typography id="session-expired-title" variant="h6" gutterBottom>
          Session expired
        </Typography>
        <Typography id="session-expired-description" variant="body2" sx={{ color: "text.secondary", mb: 3 }}>
          Your session expired. Please log in again to continue.
        </Typography>
        <Button variant="contained" onClick={handleSignIn} data-testid="session-expired-sign-in">
          Log In
        </Button>
      </Box>
    </Modal>
  );
};
